import React, { useEffect } from 'react';
import { Download, Loader2, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDataExport } from '../hooks/useDataExport';

const DataExportPage: React.FC = () => {
  useEffect(() => { document.title = 'Exportar dados'; }, []);
  const { loading, error, handleExport } = useDataExport();

  return (
    <main
      className="space-y-4 px-4 py-6"
      id="main-content"
      role="main"
      aria-label="Conteúdo principal"
    >
      <div>
        <h1 className="text-xl font-bold text-slate-900">Exportar dados</h1>
        <p className="mt-1 text-sm text-slate-500">Seus dados pessoais em formato portátil.</p>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
          <Download className="h-6 w-6" aria-hidden="true" />
        </div>
        <p className="text-sm text-slate-500">
          Você pode baixar uma cópia dos seus dados pessoais em formato JSON, conforme previsto
          pelo direito de portabilidade da LGPD.
        </p>
        <Button
          onClick={handleExport}
          disabled={loading}
          aria-label="Exportar meus dados"
          className="gap-2"
        >
          {loading ? (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          ) : (
            <Download className="h-4 w-4" aria-hidden="true" />
          )}
          {loading ? 'Exportando...' : 'Exportar meus dados'}
        </Button>
      </div>

      {error && (
        <div
          role="alert"
          aria-live="assertive"
          className="flex gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3"
        >
          <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-600" aria-hidden="true" />
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}
    </main>
  );
};

export default DataExportPage;
